import React from 'react';

const LocationMasterPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default LocationMasterPage;
